// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%2364748b%27 d=%27M3 4.5L6 7.5L9 4.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%2710%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%2364748b%27 d=%27M3 4.5L6 7.5L9 4.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 그룹 관리 모달 — AdminUserGroupMembersModal */

.agm {
  --agm-radius: 14px;
  --agm-radius-sm: 10px;
  --agm-accent: rgba(59, 130, 246, 0.95);
  --agm-accent-soft: rgba(59, 130, 246, 0.12);
  --agm-indigo: rgba(99, 102, 241, 0.92);
  --agm-indigo-soft: rgba(99, 102, 241, 0.14);
  --agm-ok: rgba(5, 150, 105, 0.98);
  --agm-bad: rgba(185, 28, 28, 0.92);
  font-family: inherit;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.agm-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 18px 10px;
  background: linear-gradient(180deg, var(--mrt-surface-2) 0%, var(--mrt-surface) 100%);
  border-bottom: 1px solid var(--mrt-border);
  position: relative;
  flex-shrink: 0;
}

.agm-header::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, rgba(59, 130, 246, 0.85), rgba(99, 102, 241, 0.75), rgba(14, 165, 233, 0.65));
  opacity: 0.95;
}

.agm-title-block {
  min-width: 0;
}

.agm-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--mrt-text);
  line-height: 1.2;
}

.agm-subtitle {
  margin: 6px 0 0;
  font-size: 0.72rem;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--mrt-muted);
}

.agm-subtitle--friendly {
  text-transform: none;
  letter-spacing: -0.01em;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.35;
  color: var(--mrt-text-2);
  max-width: 48rem;
}

.agm-header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}

.agm-btn {
  height: 32px;
  padding: 0 12px;
  border-radius: var(--agm-radius-sm);
  font-size: 0.8125rem;
  font-weight: 750;
  cursor: pointer;
  border: 1px solid var(--mrt-border);
  background: var(--mrt-surface);
  color: var(--mrt-text);
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}

.agm-btn:hover:not(:disabled) {
  background: var(--mrt-surface-2);
  border-color: rgba(15, 23, 42, 0.12);
}

.agm-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.agm-btn:disabled {
  opacity: 0.55;
  cursor: default;
}

.agm-btn--ghost {
  background: transparent;
}

.agm-btn--primary {
  border-color: rgba(59, 130, 246, 0.45);
  background: linear-gradient(180deg, rgba(59, 130, 246, 0.98), rgba(37, 99, 235, 0.95));
  color: #fff;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.28);
}

.agm-btn--primary:hover:not(:disabled) {
  filter: brightness(1.05);
  border-color: rgba(59, 130, 246, 0.6);
}

/* 닫기 등 보조 강조 — 패널 닫기는 과한 솔리드 대신 외곽선 */
.agm-btn--outline {
  background: var(--mrt-surface);
  color: rgba(37, 99, 235, 0.95);
  border-color: rgba(59, 130, 246, 0.42);
  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.08);
}

.agm-btn--outline:hover:not(:disabled) {
  background: var(--agm-accent-soft);
  border-color: rgba(59, 130, 246, 0.55);
}

.agm-body {
  padding: 10px 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.agm-body > * {
  flex-shrink: 0;
}

.agm-body > .agm-table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  flex-shrink: 1;
}

.agm-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  border-radius: var(--agm-radius-sm);
  border: 1px solid var(--mrt-border);
  background: var(--mrt-surface-2);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04) inset;
  min-width: 0;
}

/* 활성/비활성 · 검색 · 그룹 · 미승인 숨김 · 건수 — 한 줄 */
.agm-toolbar--single {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.agm-toolbar--single .agm-seg {
  flex-shrink: 0;
}

.agm-search--grow {
  flex: 1 1 200px;
  min-width: min(180px, 40vw);
  width: auto;
  max-width: none;
}

.agm-select-field--toolbar {
  flex: 0 0 auto;
  width: auto;
  min-width: 108px;
  max-width: 220px;
}

.agm-toolbar--single .agm-check {
  flex-shrink: 0;
  white-space: nowrap;
}

.agm-toolbar--single .agm-count {
  flex-shrink: 0;
  margin-left: auto;
}

.agm-check--disabled {
  opacity: 0.75;
  cursor: not-allowed;
}

.agm-check--disabled input {
  cursor: not-allowed;
}

.agm-seg {
  display: inline-flex;
  padding: 3px;
  border-radius: 12px;
  background: var(--mrt-surface);
  border: 1px solid var(--mrt-border);
  gap: 2px;
}

.agm-seg button {
  height: 28px;
  padding: 0 12px;
  border: none;
  border-radius: 9px;
  font-size: 0.8125rem;
  font-weight: 800;
  cursor: pointer;
  background: transparent;
  color: var(--mrt-text-2);
  transition: background 0.15s ease, color 0.15s ease;
}

.agm-seg button.agm-seg--on {
  background: var(--mrt-surface-2);
  color: var(--agm-accent);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.agm-seg button.agm-seg--on-danger {
  background: rgba(239, 68, 68, 0.1);
  color: var(--agm-bad);
}

.agm-search {
  height: 32px;
  padding: 0 12px;
  border-radius: var(--agm-radius-sm);
  border: 1px solid var(--mrt-border);
  background: var(--mrt-field-bg, var(--mrt-surface));
  outline: none;
  width: min(420px, 100%);
  min-width: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--mrt-text);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.agm-search:focus {
  border-color: rgba(59, 130, 246, 0.45);
  box-shadow: 0 0 0 3px var(--agm-accent-soft);
}

.agm-select-field {
  height: 32px;
  padding: 0 10px;
  padding-right: 30px;
  border-radius: var(--agm-radius-sm);
  border: 1px solid rgba(15, 23, 42, 0.1);
  background-color: var(--mrt-surface);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center right 10px;
  font-size: 0.8125rem;
  font-weight: 700;
  color: var(--mrt-text);
  cursor: pointer;
  max-width: min(280px, 92vw);
  appearance: none;
  box-shadow: 0 1px 2px rgba(2, 6, 23, 0.04);
}

.agm-check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  font-weight: 800;
  color: var(--mrt-text-2);
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}

.agm-check input {
  width: 15px;
  height: 15px;
  accent-color: var(--agm-accent);
}

.agm-count {
  font-size: 0.75rem;
  font-weight: 800;
  color: var(--mrt-muted);
  padding: 6px 10px;
  border-radius: 999px;
  background: var(--mrt-surface);
  border: 1px solid var(--mrt-border);
  white-space: nowrap;
}

.agm-alert {
  padding: 8px 12px;
  border-radius: var(--agm-radius-sm);
  font-size: 0.8125rem;
  font-weight: 750;
  line-height: 1.45;
}

.agm-alert--err {
  border: 1px solid rgba(239, 68, 68, 0.28);
  background: rgba(239, 68, 68, 0.07);
  color: var(--agm-bad);
}

.agm-alert--ok {
  border: 1px solid rgba(34, 197, 94, 0.28);
  background: rgba(34, 197, 94, 0.07);
  color: var(--agm-ok);
}

.agm-alert--info {
  border: 1px solid rgba(59, 130, 246, 0.22);
  background: var(--agm-accent-soft);
  color: var(--mrt-text-2);
}

.agm-signup-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.agm-table-wrap {
  border-radius: var(--agm-radius);
  border: 1px solid var(--mrt-border);
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(2, 6, 23, 0.06);
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* 검색 결과(표 본문)만 스크롤 — 헤더·툴바·알림은 고정 */
.agm-table-scroll {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  overflow-x: auto;
  background: var(--mrt-surface);
  -webkit-overflow-scrolling: touch;
}

.agm-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.agm-table thead th {
  position: sticky;
  top: 0;
  z-index: 3;
  text-align: left;
  padding: 6px 8px;
  font-size: inherit;
  font-weight: inherit;
  letter-spacing: normal;
  text-transform: none;
  color: inherit;
  vertical-align: bottom;
  background: linear-gradient(180deg, var(--mrt-surface-2) 0%, rgba(248, 250, 252, 0.98) 100%);
  background-color: var(--mrt-surface-2);
  border-bottom: 1px solid var(--mrt-border);
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(8px);
}

.agm-th-main {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  color: var(--mrt-text);
  letter-spacing: -0.02em;
  line-height: 1.15;
}

.agm-th-tech {
  display: block;
  margin-top: 2px;
  font-size: 0.6rem;
  font-weight: 650;
  color: var(--mrt-muted);
  letter-spacing: 0.02em;
  line-height: 1.15;
}

.agm-th--seq { width: 44px; }
.agm-th--status { width: 92px; }
.agm-th--approval { width: 82px; }
.agm-th--name { min-width: 120px; width: 14%; }
.agm-th--kakao { min-width: 200px; width: 18%; }
.agm-th--role { width: 64px; }
.agm-th--sm-name { min-width: 120px; width: 12%; }
.agm-th--sm-id { min-width: 120px; width: 10%; }
.agm-th--uid { min-width: 260px; width: 18%; }

/* 내부 UID — 제목·필드명 한 줄로 붙여 표시 */
.agm-th--uid {
  white-space: normal;
  line-height: 1.25;
}

.agm-th--uid .agm-th-main {
  display: inline;
  font-size: 0.72rem;
  line-height: 1.2;
}

.agm-th--uid .agm-th-tech {
  display: inline;
  margin-top: 0;
  margin-left: 0.15em;
  font-size: 0.58rem;
  line-height: 1.2;
  color: var(--mrt-muted);
}

.agm-th--uid .agm-th-tech::before {
  content: '·';
  display: inline;
  margin-right: 0.28em;
  color: var(--mrt-muted);
  font-weight: 800;
}
.agm-th--ws { min-width: 200px; width: 14%; }
.agm-th--save { width: 52px; text-align: center; }

.agm-th--save .agm-th-main {
  text-align: center;
  font-size: 0.68rem;
}

.agm-table tbody tr {
  transition: background 0.12s ease, box-shadow 0.12s ease;
}

.agm-table tbody tr:hover {
  background: rgba(59, 130, 246, 0.045);
  box-shadow: inset 3px 0 0 rgba(59, 130, 246, 0.35);
}

.agm-table tbody tr:nth-child(even) {
  background: rgba(15, 23, 42, 0.02);
}

.agm-table tbody tr:nth-child(even):hover {
  background: rgba(59, 130, 246, 0.06);
  box-shadow: inset 3px 0 0 rgba(59, 130, 246, 0.35);
}

.agm-table td {
  padding: 5px 8px;
  font-size: 0.78rem;
  border-bottom: 1px solid rgba(15, 23, 42, 0.05);
  vertical-align: middle;
}

.agm-seq {
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: var(--mrt-text-2);
}

.agm-select {
  height: 28px;
  border-radius: 7px;
  border: 1px solid rgba(15, 23, 42, 0.1);
  background: var(--mrt-surface);
  font-size: 0.7rem;
  font-weight: 800;
  padding: 0 8px;
  cursor: pointer;
  max-width: 100%;
  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.6);
  appearance: none;
  background-color: var(--mrt-surface);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center right 8px;
  padding-right: 24px;
}

.agm-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agm-select--narrow {
  width: 60px;
  max-width: 60px;
  padding-right: 20px;
  background-position: center right 6px;
}

.agm-select--ok {
  color: var(--agm-ok);
}

.agm-select--bad {
  color: var(--agm-bad);
}

.agm-cell-name {
  font-weight: 650;
  color: var(--mrt-text);
}

.agm-badge-lock {
  margin-left: 6px;
  font-size: 0.58rem;
  font-weight: 800;
  color: var(--mrt-muted);
  padding: 1px 6px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.05);
  border: 1px solid var(--mrt-border);
  vertical-align: middle;
}

.agm-cell-muted {
  font-weight: 600;
  color: var(--mrt-text-2);
}

.agm-btn-inline {
  height: 26px;
  padding: 0 8px;
  border-radius: 7px;
  font-size: 0.65rem;
  font-weight: 800;
  cursor: pointer;
  border: 1px solid transparent;
  white-space: nowrap;
  transition: filter 0.12s ease, transform 0.1s ease;
}

.agm-btn-inline:active:not(:disabled) {
  transform: scale(0.98);
}

.agm-btn-inline--soft {
  border: 1px solid rgba(15, 23, 42, 0.1);
  background: var(--mrt-surface);
  color: var(--mrt-text);
  box-shadow: 0 1px 2px rgba(2, 6, 23, 0.04);
}

.agm-btn-inline--soft:hover:not(:disabled) {
  border-color: rgba(59, 130, 246, 0.4);
  color: rgba(29, 78, 216, 0.98);
  background: var(--agm-accent-soft);
}

.agm-btn-inline:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agm-ws-badge {
  display: inline-block;
  font-size: 0.62rem;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 999px;
  margin-bottom: 0;
  letter-spacing: -0.01em;
  white-space: nowrap;
}

.agm-ws-badge--open {
  background: rgba(5, 150, 105, 0.1);
  color: var(--agm-ok);
  border: 1px solid rgba(5, 150, 105, 0.22);
}

.agm-ws-badge--none {
  background: rgba(245, 158, 11, 0.1);
  color: rgba(180, 83, 9, 0.95);
  border: 1px solid rgba(245, 158, 11, 0.28);
}

.agm-ws-badge--pick {
  background: var(--agm-accent-soft);
  color: rgba(29, 78, 216, 0.98);
  border: 1px solid rgba(59, 130, 246, 0.28);
}

.agm-save-cell {
  text-align: center;
  vertical-align: middle;
}

.agm-save-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 30px;
  padding: 0;
  border-radius: 9px;
  border: none;
  cursor: pointer;
  background: linear-gradient(180deg, rgba(59, 130, 246, 0.98), rgba(37, 99, 235, 0.94));
  color: #fff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.28);
  transition: filter 0.15s ease, transform 0.1s ease, box-shadow 0.15s ease;
}

.agm-save-btn__ico {
  display: block;
  flex-shrink: 0;
}

.agm-save-btn__ico--spin {
  animation: agm-save-spin 0.7s linear infinite;
}

@keyframes agm-save-spin {
  to {
    transform: rotate(360deg);
  }
}

.agm-save-btn:hover:not(:disabled) {
  filter: brightness(1.06);
  box-shadow: 0 3px 12px rgba(37, 99, 235, 0.32);
}

.agm-save-btn:active:not(:disabled) {
  transform: scale(0.96);
}

.agm-save-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.agm-uid-wrap {
  vertical-align: middle;
  min-width: 200px;
}

.agm-uid-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 26px;
}

.agm-uid-row--expanded {
  align-items: flex-start;
  flex-wrap: wrap;
}

.agm-uid-text {
  flex: 1 1;
  min-width: 0;
  font-size: 0.65rem;
  font-weight: 650;
  font-family: ui-monospace, 'SF Mono', Consolas, monospace;
  color: var(--mrt-muted);
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agm-uid-text--expanded {
  white-space: pre-wrap;
  word-break: break-all;
  overflow: visible;
  text-overflow: unset;
  flex: 1 1 100%;
}

.agm-uid-actions {
  display: inline-flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  gap: 3px;
  align-items: center;
}

.agm-uid-row--expanded .agm-uid-actions {
  margin-left: auto;
}

.agm-btn-micro {
  height: 20px;
  padding: 0 6px;
  border-radius: 5px;
  font-size: 0.58rem;
  font-weight: 800;
  cursor: pointer;
  border: 1px solid var(--mrt-border);
  background: var(--mrt-surface-2);
  color: var(--mrt-text-2);
  transition: background 0.12s ease, border-color 0.12s ease;
}

.agm-btn-micro:hover {
  border-color: rgba(59, 130, 246, 0.35);
  color: rgba(29, 78, 216, 0.95);
  background: var(--agm-accent-soft);
}

.agm-menu-cell-wrap {
  vertical-align: middle;
}

.agm-menu-cell {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.agm-cell-flex {
  display: flex;
  align-items: center;
  gap: 6px;
}

.agm-cell-truncate {
  min-width: 0;
  font-size: 0.75rem;
  font-weight: 800;
  color: var(--mrt-text-2);
}

/* 서브 다이얼로그 (그룹 트리 / 워크스페이스 권한) */
.agm-sub-header {
  padding: 18px 20px;
  border-bottom: 1px solid var(--mrt-border);
  background: linear-gradient(180deg, var(--mrt-surface-2), var(--mrt-surface));
  flex-shrink: 0;
}

.agm-sub-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 800;
  color: var(--mrt-text);
}

.agm-sub-desc {
  margin: 6px 0 0;
  font-size: 0.8125rem;
  color: var(--mrt-muted);
  font-weight: 650;
}

.agm-ws-list {
  display: grid;
  gap: 10px;
}

.agm-ws-list--disabled {
  opacity: 0.45;
  pointer-events: none;
  transition: opacity 0.15s ease;
}

.agm-ws-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-radius: var(--agm-radius-sm);
  border: 1px solid var(--mrt-border);
  background: var(--mrt-surface-2);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.agm-ws-item:hover {
  border-color: rgba(99, 102, 241, 0.35);
  background: rgba(99, 102, 241, 0.06);
}

.agm-ws-item input {
  margin-top: 3px;
  accent-color: var(--agm-indigo);
}

.agm-ws-item-title {
  font-size: 0.875rem;
  font-weight: 750;
  color: var(--mrt-text);
}

.agm-ws-item-id {
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--mrt-muted);
  margin-top: 4px;
  font-family: ui-monospace, monospace;
}

.agm-sub-footer {
  padding: 14px 20px;
  border-top: 1px solid var(--mrt-border);
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: var(--mrt-surface-2);
}

.agm-group-embed {
  padding: 10px 12px;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.agm-ws-scroll {
  padding: 16px 20px;
  display: grid;
  gap: 14px;
  max-height: calc(88vh - 140px);
  overflow: auto;
}

.agm-ws-hint {
  font-size: 0.8125rem;
  font-weight: 750;
  color: var(--mrt-text-2);
  line-height: 1.45;
}

.agm-ws-check-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.8125rem;
  font-weight: 800;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.agm-ws-check-row input {
  accent-color: var(--agm-accent);
}

.agm-sub-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.agm-sub-desc-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminUserGroupMembersModal.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;EACtC,2CAA2C;EAC3C,sCAAsC;EACtC,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,oBAAoB;EACpB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,qFAAqF;EACrF,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,WAAW;EACX,gHAAgH;EAChH,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,8BAA8B;EAC9B,sBAAsB;EACtB,+EAA+E;AACjF;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,sFAAsF;EACtF,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA,sCAAsC;AACtC;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,mDAAmD;EACnD,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,mCAAmC;EACnC,mDAAmD;EACnD,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,uCAAuC;EACvC,oCAAoC;EACpC,yDAAgM;EAChM,4BAA4B;EAC5B,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,4FAA4F;EAC5F,sCAAsC;EACtC,0CAA0C;EAC1C,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,eAAe,WAAW,EAAE;AAC5B,kBAAkB,WAAW,EAAE;AAC/B,oBAAoB,WAAW,EAAE;AACjC,gBAAgB,gBAAgB,EAAE,UAAU,EAAE;AAC9C,iBAAiB,gBAAgB,EAAE,UAAU,EAAE;AAC/C,gBAAgB,WAAW,EAAE;AAC7B,mBAAmB,gBAAgB,EAAE,UAAU,EAAE;AACjD,iBAAiB,gBAAgB,EAAE,UAAU,EAAE;AAC/C,eAAe,gBAAgB,EAAE,UAAU,EAAE;;AAE7C,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;AACA,cAAc,gBAAgB,EAAE,UAAU,EAAE;AAC5C,gBAAgB,WAAW,EAAE,kBAAkB,EAAE;;AAEjD;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oDAAoD;EACpD,gBAAgB;EAChB,oCAAoC;EACpC,yDAAgM;EAChM,4BAA4B;EAC5B,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sFAAsF;EACtF,WAAW;EACX,6CAA6C;EAC7C,yEAAyE;AAC3E;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yDAAyD;EACzD,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,gCAAgC;EAChC,wBAAwB;EACxB,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,6EAA6E;EAC7E,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["/* 그룹 관리 모달 — AdminUserGroupMembersModal */\n\n.agm {\n  --agm-radius: 14px;\n  --agm-radius-sm: 10px;\n  --agm-accent: rgba(59, 130, 246, 0.95);\n  --agm-accent-soft: rgba(59, 130, 246, 0.12);\n  --agm-indigo: rgba(99, 102, 241, 0.92);\n  --agm-indigo-soft: rgba(99, 102, 241, 0.14);\n  --agm-ok: rgba(5, 150, 105, 0.98);\n  --agm-bad: rgba(185, 28, 28, 0.92);\n  font-family: inherit;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.agm-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 18px 10px;\n  background: linear-gradient(180deg, var(--mrt-surface-2) 0%, var(--mrt-surface) 100%);\n  border-bottom: 1px solid var(--mrt-border);\n  position: relative;\n  flex-shrink: 0;\n}\n\n.agm-header::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, rgba(59, 130, 246, 0.85), rgba(99, 102, 241, 0.75), rgba(14, 165, 233, 0.65));\n  opacity: 0.95;\n}\n\n.agm-title-block {\n  min-width: 0;\n}\n\n.agm-title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--mrt-text);\n  line-height: 1.2;\n}\n\n.agm-subtitle {\n  margin: 6px 0 0;\n  font-size: 0.72rem;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--mrt-muted);\n}\n\n.agm-subtitle--friendly {\n  text-transform: none;\n  letter-spacing: -0.01em;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.35;\n  color: var(--mrt-text-2);\n  max-width: 48rem;\n}\n\n.agm-header-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.agm-btn {\n  height: 32px;\n  padding: 0 12px;\n  border-radius: var(--agm-radius-sm);\n  font-size: 0.8125rem;\n  font-weight: 750;\n  cursor: pointer;\n  border: 1px solid var(--mrt-border);\n  background: var(--mrt-surface);\n  color: var(--mrt-text);\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;\n}\n\n.agm-btn:hover:not(:disabled) {\n  background: var(--mrt-surface-2);\n  border-color: rgba(15, 23, 42, 0.12);\n}\n\n.agm-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.agm-btn:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.agm-btn--ghost {\n  background: transparent;\n}\n\n.agm-btn--primary {\n  border-color: rgba(59, 130, 246, 0.45);\n  background: linear-gradient(180deg, rgba(59, 130, 246, 0.98), rgba(37, 99, 235, 0.95));\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.28);\n}\n\n.agm-btn--primary:hover:not(:disabled) {\n  filter: brightness(1.05);\n  border-color: rgba(59, 130, 246, 0.6);\n}\n\n/* 닫기 등 보조 강조 — 패널 닫기는 과한 솔리드 대신 외곽선 */\n.agm-btn--outline {\n  background: var(--mrt-surface);\n  color: rgba(37, 99, 235, 0.95);\n  border-color: rgba(59, 130, 246, 0.42);\n  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.08);\n}\n\n.agm-btn--outline:hover:not(:disabled) {\n  background: var(--agm-accent-soft);\n  border-color: rgba(59, 130, 246, 0.55);\n}\n\n.agm-body {\n  padding: 10px 16px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.agm-body > * {\n  flex-shrink: 0;\n}\n\n.agm-body > .agm-table-wrap {\n  flex: 1 1 auto;\n  min-height: 0;\n  flex-shrink: 1;\n}\n\n.agm-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 10px;\n  border-radius: var(--agm-radius-sm);\n  border: 1px solid var(--mrt-border);\n  background: var(--mrt-surface-2);\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04) inset;\n  min-width: 0;\n}\n\n/* 활성/비활성 · 검색 · 그룹 · 미승인 숨김 · 건수 — 한 줄 */\n.agm-toolbar--single {\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n.agm-toolbar--single .agm-seg {\n  flex-shrink: 0;\n}\n\n.agm-search--grow {\n  flex: 1 1 200px;\n  min-width: min(180px, 40vw);\n  width: auto;\n  max-width: none;\n}\n\n.agm-select-field--toolbar {\n  flex: 0 0 auto;\n  width: auto;\n  min-width: 108px;\n  max-width: 220px;\n}\n\n.agm-toolbar--single .agm-check {\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.agm-toolbar--single .agm-count {\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.agm-check--disabled {\n  opacity: 0.75;\n  cursor: not-allowed;\n}\n\n.agm-check--disabled input {\n  cursor: not-allowed;\n}\n\n.agm-seg {\n  display: inline-flex;\n  padding: 3px;\n  border-radius: 12px;\n  background: var(--mrt-surface);\n  border: 1px solid var(--mrt-border);\n  gap: 2px;\n}\n\n.agm-seg button {\n  height: 28px;\n  padding: 0 12px;\n  border: none;\n  border-radius: 9px;\n  font-size: 0.8125rem;\n  font-weight: 800;\n  cursor: pointer;\n  background: transparent;\n  color: var(--mrt-text-2);\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.agm-seg button.agm-seg--on {\n  background: var(--mrt-surface-2);\n  color: var(--agm-accent);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.agm-seg button.agm-seg--on-danger {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--agm-bad);\n}\n\n.agm-search {\n  height: 32px;\n  padding: 0 12px;\n  border-radius: var(--agm-radius-sm);\n  border: 1px solid var(--mrt-border);\n  background: var(--mrt-field-bg, var(--mrt-surface));\n  outline: none;\n  width: min(420px, 100%);\n  min-width: 0;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--mrt-text);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.agm-search:focus {\n  border-color: rgba(59, 130, 246, 0.45);\n  box-shadow: 0 0 0 3px var(--agm-accent-soft);\n}\n\n.agm-select-field {\n  height: 32px;\n  padding: 0 10px;\n  padding-right: 30px;\n  border-radius: var(--agm-radius-sm);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  background-color: var(--mrt-surface);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2364748b' d='M3 4.5L6 7.5L9 4.5'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center right 10px;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: var(--mrt-text);\n  cursor: pointer;\n  max-width: min(280px, 92vw);\n  appearance: none;\n  box-shadow: 0 1px 2px rgba(2, 6, 23, 0.04);\n}\n\n.agm-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.75rem;\n  font-weight: 800;\n  color: var(--mrt-text-2);\n  user-select: none;\n  cursor: pointer;\n}\n\n.agm-check input {\n  width: 15px;\n  height: 15px;\n  accent-color: var(--agm-accent);\n}\n\n.agm-count {\n  font-size: 0.75rem;\n  font-weight: 800;\n  color: var(--mrt-muted);\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: var(--mrt-surface);\n  border: 1px solid var(--mrt-border);\n  white-space: nowrap;\n}\n\n.agm-alert {\n  padding: 8px 12px;\n  border-radius: var(--agm-radius-sm);\n  font-size: 0.8125rem;\n  font-weight: 750;\n  line-height: 1.45;\n}\n\n.agm-alert--err {\n  border: 1px solid rgba(239, 68, 68, 0.28);\n  background: rgba(239, 68, 68, 0.07);\n  color: var(--agm-bad);\n}\n\n.agm-alert--ok {\n  border: 1px solid rgba(34, 197, 94, 0.28);\n  background: rgba(34, 197, 94, 0.07);\n  color: var(--agm-ok);\n}\n\n.agm-alert--info {\n  border: 1px solid rgba(59, 130, 246, 0.22);\n  background: var(--agm-accent-soft);\n  color: var(--mrt-text-2);\n}\n\n.agm-signup-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.agm-table-wrap {\n  border-radius: var(--agm-radius);\n  border: 1px solid var(--mrt-border);\n  overflow: hidden;\n  box-shadow: 0 4px 24px rgba(2, 6, 23, 0.06);\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n/* 검색 결과(표 본문)만 스크롤 — 헤더·툴바·알림은 고정 */\n.agm-table-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  overflow-x: auto;\n  background: var(--mrt-surface);\n  -webkit-overflow-scrolling: touch;\n}\n\n.agm-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.agm-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  text-align: left;\n  padding: 6px 8px;\n  font-size: inherit;\n  font-weight: inherit;\n  letter-spacing: normal;\n  text-transform: none;\n  color: inherit;\n  vertical-align: bottom;\n  background: linear-gradient(180deg, var(--mrt-surface-2) 0%, rgba(248, 250, 252, 0.98) 100%);\n  background-color: var(--mrt-surface-2);\n  border-bottom: 1px solid var(--mrt-border);\n  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.06);\n  backdrop-filter: blur(8px);\n}\n\n.agm-th-main {\n  display: block;\n  font-size: 0.72rem;\n  font-weight: 800;\n  color: var(--mrt-text);\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n}\n\n.agm-th-tech {\n  display: block;\n  margin-top: 2px;\n  font-size: 0.6rem;\n  font-weight: 650;\n  color: var(--mrt-muted);\n  letter-spacing: 0.02em;\n  line-height: 1.15;\n}\n\n.agm-th--seq { width: 44px; }\n.agm-th--status { width: 92px; }\n.agm-th--approval { width: 82px; }\n.agm-th--name { min-width: 120px; width: 14%; }\n.agm-th--kakao { min-width: 200px; width: 18%; }\n.agm-th--role { width: 64px; }\n.agm-th--sm-name { min-width: 120px; width: 12%; }\n.agm-th--sm-id { min-width: 120px; width: 10%; }\n.agm-th--uid { min-width: 260px; width: 18%; }\n\n/* 내부 UID — 제목·필드명 한 줄로 붙여 표시 */\n.agm-th--uid {\n  white-space: normal;\n  line-height: 1.25;\n}\n\n.agm-th--uid .agm-th-main {\n  display: inline;\n  font-size: 0.72rem;\n  line-height: 1.2;\n}\n\n.agm-th--uid .agm-th-tech {\n  display: inline;\n  margin-top: 0;\n  margin-left: 0.15em;\n  font-size: 0.58rem;\n  line-height: 1.2;\n  color: var(--mrt-muted);\n}\n\n.agm-th--uid .agm-th-tech::before {\n  content: '·';\n  display: inline;\n  margin-right: 0.28em;\n  color: var(--mrt-muted);\n  font-weight: 800;\n}\n.agm-th--ws { min-width: 200px; width: 14%; }\n.agm-th--save { width: 52px; text-align: center; }\n\n.agm-th--save .agm-th-main {\n  text-align: center;\n  font-size: 0.68rem;\n}\n\n.agm-table tbody tr {\n  transition: background 0.12s ease, box-shadow 0.12s ease;\n}\n\n.agm-table tbody tr:hover {\n  background: rgba(59, 130, 246, 0.045);\n  box-shadow: inset 3px 0 0 rgba(59, 130, 246, 0.35);\n}\n\n.agm-table tbody tr:nth-child(even) {\n  background: rgba(15, 23, 42, 0.02);\n}\n\n.agm-table tbody tr:nth-child(even):hover {\n  background: rgba(59, 130, 246, 0.06);\n  box-shadow: inset 3px 0 0 rgba(59, 130, 246, 0.35);\n}\n\n.agm-table td {\n  padding: 5px 8px;\n  font-size: 0.78rem;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.05);\n  vertical-align: middle;\n}\n\n.agm-seq {\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: var(--mrt-text-2);\n}\n\n.agm-select {\n  height: 28px;\n  border-radius: 7px;\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  background: var(--mrt-surface);\n  font-size: 0.7rem;\n  font-weight: 800;\n  padding: 0 8px;\n  cursor: pointer;\n  max-width: 100%;\n  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.6);\n  appearance: none;\n  background-color: var(--mrt-surface);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 12 12'%3E%3Cpath fill='%2364748b' d='M3 4.5L6 7.5L9 4.5'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center right 8px;\n  padding-right: 24px;\n}\n\n.agm-select:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.agm-select--narrow {\n  width: 60px;\n  max-width: 60px;\n  padding-right: 20px;\n  background-position: center right 6px;\n}\n\n.agm-select--ok {\n  color: var(--agm-ok);\n}\n\n.agm-select--bad {\n  color: var(--agm-bad);\n}\n\n.agm-cell-name {\n  font-weight: 650;\n  color: var(--mrt-text);\n}\n\n.agm-badge-lock {\n  margin-left: 6px;\n  font-size: 0.58rem;\n  font-weight: 800;\n  color: var(--mrt-muted);\n  padding: 1px 6px;\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.05);\n  border: 1px solid var(--mrt-border);\n  vertical-align: middle;\n}\n\n.agm-cell-muted {\n  font-weight: 600;\n  color: var(--mrt-text-2);\n}\n\n.agm-btn-inline {\n  height: 26px;\n  padding: 0 8px;\n  border-radius: 7px;\n  font-size: 0.65rem;\n  font-weight: 800;\n  cursor: pointer;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  transition: filter 0.12s ease, transform 0.1s ease;\n}\n\n.agm-btn-inline:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.agm-btn-inline--soft {\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  background: var(--mrt-surface);\n  color: var(--mrt-text);\n  box-shadow: 0 1px 2px rgba(2, 6, 23, 0.04);\n}\n\n.agm-btn-inline--soft:hover:not(:disabled) {\n  border-color: rgba(59, 130, 246, 0.4);\n  color: rgba(29, 78, 216, 0.98);\n  background: var(--agm-accent-soft);\n}\n\n.agm-btn-inline:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.agm-ws-badge {\n  display: inline-block;\n  font-size: 0.62rem;\n  font-weight: 800;\n  padding: 2px 8px;\n  border-radius: 999px;\n  margin-bottom: 0;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n}\n\n.agm-ws-badge--open {\n  background: rgba(5, 150, 105, 0.1);\n  color: var(--agm-ok);\n  border: 1px solid rgba(5, 150, 105, 0.22);\n}\n\n.agm-ws-badge--none {\n  background: rgba(245, 158, 11, 0.1);\n  color: rgba(180, 83, 9, 0.95);\n  border: 1px solid rgba(245, 158, 11, 0.28);\n}\n\n.agm-ws-badge--pick {\n  background: var(--agm-accent-soft);\n  color: rgba(29, 78, 216, 0.98);\n  border: 1px solid rgba(59, 130, 246, 0.28);\n}\n\n.agm-save-cell {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.agm-save-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 30px;\n  padding: 0;\n  border-radius: 9px;\n  border: none;\n  cursor: pointer;\n  background: linear-gradient(180deg, rgba(59, 130, 246, 0.98), rgba(37, 99, 235, 0.94));\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.28);\n  transition: filter 0.15s ease, transform 0.1s ease, box-shadow 0.15s ease;\n}\n\n.agm-save-btn__ico {\n  display: block;\n  flex-shrink: 0;\n}\n\n.agm-save-btn__ico--spin {\n  animation: agm-save-spin 0.7s linear infinite;\n}\n\n@keyframes agm-save-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.agm-save-btn:hover:not(:disabled) {\n  filter: brightness(1.06);\n  box-shadow: 0 3px 12px rgba(37, 99, 235, 0.32);\n}\n\n.agm-save-btn:active:not(:disabled) {\n  transform: scale(0.96);\n}\n\n.agm-save-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.agm-uid-wrap {\n  vertical-align: middle;\n  min-width: 200px;\n}\n\n.agm-uid-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 26px;\n}\n\n.agm-uid-row--expanded {\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.agm-uid-text {\n  flex: 1;\n  min-width: 0;\n  font-size: 0.65rem;\n  font-weight: 650;\n  font-family: ui-monospace, 'SF Mono', Consolas, monospace;\n  color: var(--mrt-muted);\n  line-height: 1.25;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agm-uid-text--expanded {\n  white-space: pre-wrap;\n  word-break: break-all;\n  overflow: visible;\n  text-overflow: unset;\n  flex: 1 1 100%;\n}\n\n.agm-uid-actions {\n  display: inline-flex;\n  flex-shrink: 0;\n  flex-wrap: nowrap;\n  gap: 3px;\n  align-items: center;\n}\n\n.agm-uid-row--expanded .agm-uid-actions {\n  margin-left: auto;\n}\n\n.agm-btn-micro {\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 5px;\n  font-size: 0.58rem;\n  font-weight: 800;\n  cursor: pointer;\n  border: 1px solid var(--mrt-border);\n  background: var(--mrt-surface-2);\n  color: var(--mrt-text-2);\n  transition: background 0.12s ease, border-color 0.12s ease;\n}\n\n.agm-btn-micro:hover {\n  border-color: rgba(59, 130, 246, 0.35);\n  color: rgba(29, 78, 216, 0.95);\n  background: var(--agm-accent-soft);\n}\n\n.agm-menu-cell-wrap {\n  vertical-align: middle;\n}\n\n.agm-menu-cell {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.agm-cell-flex {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.agm-cell-truncate {\n  min-width: 0;\n  font-size: 0.75rem;\n  font-weight: 800;\n  color: var(--mrt-text-2);\n}\n\n/* 서브 다이얼로그 (그룹 트리 / 워크스페이스 권한) */\n.agm-sub-header {\n  padding: 18px 20px;\n  border-bottom: 1px solid var(--mrt-border);\n  background: linear-gradient(180deg, var(--mrt-surface-2), var(--mrt-surface));\n  flex-shrink: 0;\n}\n\n.agm-sub-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--mrt-text);\n}\n\n.agm-sub-desc {\n  margin: 6px 0 0;\n  font-size: 0.8125rem;\n  color: var(--mrt-muted);\n  font-weight: 650;\n}\n\n.agm-ws-list {\n  display: grid;\n  gap: 10px;\n}\n\n.agm-ws-list--disabled {\n  opacity: 0.45;\n  pointer-events: none;\n  transition: opacity 0.15s ease;\n}\n\n.agm-ws-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: var(--agm-radius-sm);\n  border: 1px solid var(--mrt-border);\n  background: var(--mrt-surface-2);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.agm-ws-item:hover {\n  border-color: rgba(99, 102, 241, 0.35);\n  background: rgba(99, 102, 241, 0.06);\n}\n\n.agm-ws-item input {\n  margin-top: 3px;\n  accent-color: var(--agm-indigo);\n}\n\n.agm-ws-item-title {\n  font-size: 0.875rem;\n  font-weight: 750;\n  color: var(--mrt-text);\n}\n\n.agm-ws-item-id {\n  display: block;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: var(--mrt-muted);\n  margin-top: 4px;\n  font-family: ui-monospace, monospace;\n}\n\n.agm-sub-footer {\n  padding: 14px 20px;\n  border-top: 1px solid var(--mrt-border);\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  background: var(--mrt-surface-2);\n}\n\n.agm-group-embed {\n  padding: 10px 12px;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.agm-ws-scroll {\n  padding: 16px 20px;\n  display: grid;\n  gap: 14px;\n  max-height: calc(88vh - 140px);\n  overflow: auto;\n}\n\n.agm-ws-hint {\n  font-size: 0.8125rem;\n  font-weight: 750;\n  color: var(--mrt-text-2);\n  line-height: 1.45;\n}\n\n.agm-ws-check-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.8125rem;\n  font-weight: 800;\n  cursor: pointer;\n  user-select: none;\n}\n\n.agm-ws-check-row input {\n  accent-color: var(--agm-accent);\n}\n\n.agm-sub-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.agm-sub-desc-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
